import { AbstractHex } from './AbstractHex';

export class BaseHex extends AbstractHex {}
